__turbopack_context__.v({
  "arrowIconImage": "card-module-scss-module__hUGO7q__arrowIconImage",
  "card": "card-module-scss-module__hUGO7q__card",
  "cardActive": "card-module-scss-module__hUGO7q__cardActive",
  "cardArrow": "card-module-scss-module__hUGO7q__cardArrow",
  "cardHovered": "card-module-scss-module__hUGO7q__cardHovered",
  "cardImage": "card-module-scss-module__hUGO7q__cardImage",
  "cardLink": "card-module-scss-module__hUGO7q__cardLink",
  "noLink": "card-module-scss-module__hUGO7q__noLink",
  "secondary": "card-module-scss-module__hUGO7q__secondary",
});
